import { Requests } from "./Requests"
import endpoints from '../../endpoints'

const WEB_APP_URL = endpoints.WEB_APP

export default class UserHelpers {

  /**
   * User by Email
   * @returns {Object}
   */
  static async getByEmail(email){
    if (!email) {
      console.error("No email provided to search on")
      return
    }
    const url = `${WEB_APP_URL}/api/user/email/${email}`
    const user = await Requests.authRequest(url, 'GET')
    return user
  }

  static async getAliasUsers(orgId){
    const params = new URLSearchParams({ organizationId: orgId })
    const url = `${WEB_APP_URL}/api/alias-operators?${params.toString()}`
    const aliasUsers = await Requests.authRequest(url, 'GET', null, true)
    return aliasUsers
  }

  static async getHiMarleyUsers(){
    const url = `${WEB_APP_URL}/api/user/userlist?role=operator&status=active&sort=profile.firstName&order=ASC`
    const aliasUsers = await Requests.authRequest(url, 'GET')
    return aliasUsers.users
  }

  static async createAliasUser(email, organizationId){
    const url = `${WEB_APP_URL}/api/alias-operators`
    const aliasUser = await Requests.authRequest(url, 'POST', { email, organizationId }, true)
    return aliasUser
  }

  static async reactivateAliasUser(aliasId, organizationId) {
    const url = `${WEB_APP_URL}/api/alias-operators/${aliasId}`
    const body = { organizationId }
    const activatedUser = await Requests.authRequest(url, 'PUT', body, true)
    return activatedUser
  }

  static async deactivateAliasUser(aliasId, organizationId) {
    const params = new URLSearchParams({ organizationId })
    const url = `${WEB_APP_URL}/api/alias-operators/${aliasId}?${params.toString()}`
    const deactivatedUser = await Requests.authRequest(url, 'DELETE', null, true)
    return deactivatedUser
  }
}